module.exports = __webpack_public_path__ + "img/dgitem2.075acae3.png";